// extracted by mini-css-extract-plugin
export var alignCenter = "_9h-d";
export var bannerShown = "_9h-6";
export var buttonContent = "_9h-0";
export var cardList = "_9h-1";
export var centerContent = "_9h-2";
export var chevron = "_9h-3";
export var closePanelButton = "_9h-k";
export var conversationContextContainer = "_9h-l";
export var conversationDetailContainer = "_9h-4";
export var detailWrapper = "_9h-7";
export var dropdownButton = "_9h-e";
export var dropdownTitle = "_9h-9";
export var fullHeight = "_9h-5";
export var hidden = "_9h-a";
export var icon = "_9h-b";
export var mergeSuggestionWrapper = "_9h-m";
export var panel = "_9h-i";
export var portalButtonsWrapper = "_9h-c";
export var right = "_9h-j";
export var tableSummaryContainer = "_9h-8";
export var tableSummaryHeader = "_9h-g";
export var threeDotsButton = "_9h-f";
export var wide = "_9h-h";